
<template>
  <!-- <div> -->
  <el-container id="myhead">
    <el-header class='mb-30'>
      <el-row class="shadow center">
        <xingluo @goOutLogin='goOutLogin'></xingluo>
      </el-row>
      <el-row class='heads-b flex'>
        <!-- <div class='heads-c'> -->
          <!-- <img src='../../assets/my/new_logo.png' class='new_logo'/> -->
          <!-- <span class='new_jiange'></span>
          <span class='new_title'>大数据合作平台</span> -->
        <!-- </div> -->
        
        

        <!-- <img
          src="../../assets/hezuo.png"
          class="xingluo ml-60 cursor"
          @click="goFirst"
          v-if="router!='my'"
        >
        <img
          src="../../assets/my/center.png"
          class="xingluo ml-60 cursor"
          v-if="router=='my'"
          @click="goFirst"
        > -->
      </el-row>
    </el-header>
  </el-container>
  <!-- </div> -->
</template>

<script>
import { setTimeout } from "timers";
import xingluo from 'xingluo_components/heads.vue';
export default {
  name: "myhead",
  data() {
    return {
      user_info: ""
    };
  },
  components: {
   xingluo:xingluo
  },
  created() {
    this.getuserInfo();
  },
  props: ["router"],
  mounted() {},
  methods: {
    // 退出登录
    outlogin() {
      this.$http({
        method: "POST",
        url: "/home/userLogout"
      })
        .then(res => {
          if (res && res.code == 1) {
            this.$message("退出成功");
            this.$http.removeAuth("user_info");
            this.$http.removeAuth("auth_token");
            sessionStorage.setItem("activeIndex", "");
            window.location.href = `https://www.linkstars.com`;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    goMyinfo() {
      this.$router.push({
        name: "myinfo",
        params: {}
      });
    },
    getuserInfo() {
      if (this.$http.getAuth("user_info")) {
        let user_info = this.$http.getAuth("user_info");
        this.user_info = user_info;
      }
    },
    setHeader(num) {
      if (num == 1) {
        this.$router.push({
          name: "overview",
          params: {}
        });
      }
    },
    goList() {
      window.location.href = "https://xl.linkstars.com/list/list";
    },
    //回到首页列表
    goFirst() {
      window.location.href = "https://www.linkstars.com";
    },
    goOutLogin(data){
      this.$router.push({
        name: "login",
        query: {
          type:'login'
        }
      });
      
      
    }
  }
};
</script>
<style  scoped>
.flex {
  display: flex;
}
.flex-d {
  flex-direction: row-reverse;
}
.fz-18 {
  font-size: 18px;
}
.shadow {
  box-shadow: 0 2px 4px 0 rgba(215, 215, 215, 0.5);
}
.top {
  width: 1190px;
  height: 40px;

  margin: 0 auto;
}
.right {
  text-align: right;
}

.c-303 {
  color: #303133;
}
.line-40 {
  line-height: 40px;
}
.ml-20 {
  margin-left: 20px;
}
.ml-60 {
  margin-left: 60px;
}
.mt-10 {
  margin-top: 10px;
}
.ml-8 {
  margin-left: 8px;
}
.cursor {
  cursor: pointer;
}
.hover-r:hover {
  color: #f04848;
}
.xingluo {
  height: 60px;
  margin-top: 25px;
}
.center {
  display: flex;
  justify-content: center;
}
.heads-b{
  /* height:100px; */
  box-shadow: 0 2px 11px 0 rgba(215,215,215,0.50);
  position:relative;
  z-index:999;
  justify-content: center;
}
.heads-c{
  width:1200px;
  display: flex;
}
.new_logo{
  width:108px;
  height:70px;
  margin:14px 0 15px 0px;
}
.new_jiange{
  width:2px;
  height:29px;
  background:#f1f1f1;
  margin:37px 15px 0 15px;
}
.new_title{
  font-size:20px;
  color:#333;
  line-height:28px;
  margin-top:35px;
}
.mb-30{
  margin-bottom:30px;
}
</style>